<template>
	<div id="app">
		<transition :name="transitionName">
			<router-view :class="models"></router-view>
		</transition>
	</div>
</template>

<script>
import event from "@/utils/event";
import native from '@/utils/jsbridge'
import session from '@/utils/session'
import { getQueryString } from '@/utils/helper'
import bowser from 'bowser'


export default {
	name: "App",
	data() {
		return {
			transitionName: "",//slide-right
			models: bowser.ios ? 'ios' : 'android'
		};
	},
	beforeMount() {
		const that = this;
		const token = getQueryString('token') || ''
		token && session.set('$$token', token)

		event.on("update_header", (config) => {
			let leftBtnConf = config.leftBtn || {}
			let rightBtnConf = config.rightBtn
			const fromNative = getQueryString('fromNative') || ''
			if (leftBtnConf && leftBtnConf.success) {
				const func = leftBtnConf.success
				leftBtnConf.success = () => func()
				leftBtnConf = {
					...{
						name: '返回',
						success: () => {
							this.$router.back(-1)
						},
						...leftBtnConf,
					}
				}
			}
			if (fromNative === '1') {
				leftBtnConf = {
					...leftBtnConf,
					...{
						name: '返回',
						success: () => {
							native.closeWebView()
						}
					}
				}
			}



			if (rightBtnConf && rightBtnConf.success) {
				const func = rightBtnConf.success
				rightBtnConf.success = () => func()
				rightBtnConf = {
					...{
						isHas: 'false', // 是否有右btn
						entra: 'false', // 是否为图片
						...rightBtnConf
					}
				}
			}


			let nativeConf = {
				title: config.title || that.$router.meta.title || "破风",
				leftBtn: leftBtnConf,
				rightBtn: rightBtnConf
			}
			native.setTitle(nativeConf)

		});
	},
	watch: {
		// $route(to, from) {
		// 	const toDepth = to.meta.index;
		// 	const fromDepth = from.meta.index;
		// 	this.transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";
		// 	// console.log(to.path, toDepth, from.path, fromDepth, this.transitionName);
		// },
		$route(to, from) {


			// const toDepth = to.meta.index;
			// const fromDepth = from.meta.index;
			// this.transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";
			// if (from.name === null) {
			// 	this.transitionName = "";
			// } else {
			// 	if (!this.map[to.fullPath]) {
			// 		this.map[to.fullPath] = +new Date() + 1;
			// 	}
			// 	if (!this.map[from.fullPath]) {
			// 		this.map[from.fullPath] = +new Date();
			// 	}
			// 	if (this.map[to.fullPath] > this.map[from.fullPath]) {
			// 		// 到子页面
			// 		this.transitionName = "slide-forward";
			// 	} else {
			// 		// 到父页面
			// 		this.transitionName = "slide-back";
			// 	}
			// }
			// 到父页面
		}
	},
	beforeDestroy() {
		event.removeListener('update_header')
	},
};
</script>

<style scope lang="less">
html,
body {
	width: 100%;
	height: 100%;
	// background-color: #f5f5f5;
	// background-color: #fff;
	font-family: SourceHanSansCN-Regular;
}

#app {
	height: 100%;
	color: #2c3e50;
	width: 100%;
	// background-color: #fff;

	//   .child-view {
	//     width: 100%;
	//     height: 100%;
	//     transition: all .5s cubic-bezier(.55,0,.1,1);
	// }
	// .slide-left-enter,
	// .slide-right-leave-active {
	//   opacity: 0;
	//   -webkit-transform: translate(30px, 0);
	//   transform: translate(30px, 0);
	// }
	// .slide-left-leave-active, .slide-right-enter {
	//   opacity: 0;
	//   -webkit-transform: translate(-30px, 0);
	//   transform: translate(-30px, 0);
	// }
	.slide-right-enter-active,
	.slide-right-leave-active,
	.slide-left-enter-active,
	.slide-left-leave-active {
		will-change: transform;
		transition: all 500ms;
		position: absolute;
	}

	.slide-right-enter {
		opacity: 0;
		transform: translate3d(-100%, 0, 0);
	}

	.slide-right-leave-active {
		opacity: 0;
		transform: translate3d(100%, 0, 0);
	}

	.slide-left-enter {
		opacity: 0;
		transform: translate3d(100%, 0, 0);
	}

	.slide-left-leave-active {
		opacity: 0;
		transform: translate3d(-100%, 0, 0);
	}

	div {
		box-sizing: border-box;
	}

	.null-data {
		color: #969799;
		font-size: 14px;
		line-height: 1.6;
		text-align: center;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
}

.mask-fl {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	width: 375px;
	height: 100vh;
	background: #000000;
	border-radius: 0px 0px 0px 0px;
	opacity: 0.3;
	z-index: 899;
}

.over {
	white-space: nowrap;
	overflow: hidden;
	-o-text-overflow: ellipsis;
	text-overflow: ellipsis;
	display: block;
}

.over2 {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
}

.boxfir {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-start;
	/* 两端 */
}

.boxsec {
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	align-items: center;
	/* 水平居中 */
}

.boxthi {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	/* 垂直居中 */
}

.h60 {
	height: 60px;
}

.h80 {
	height: 80px;
}

/*new*/
.fxbetween {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-start;
}

.fxcenter {
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	align-items: center;
}

.fxvercenter {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
}

/*筛选项*/
.filter-top .van-dropdown-menu__bar {
	box-shadow: none !important;
}

.filter-top .van-cell {
	height: 44px;
	font-size: 16px;
	color: #000000;
	line-height: 44px;
	padding: 0 10px;
	display: inline-block;
	background: #f5f5f5;
	margin: 0 0 15px 15px;
	border-radius: 5px;
	float: left;
	width: auto;
}

.filter-top .van-dropdown-menu__title--active {
	color: #FFAA00;
}

.filter-top .van-popup {
	border-radius: 0 0 10px 10px;
}

/*收缩展开*/
.dian-info {
	padding-bottom: 30px;

	.van-collapse-item__title {
		position: absolute;
		bottom: -30px;
		z-index: 10;
		padding: 0;
		width: 80px;
		left: 50%;
		margin-left: -40px;
		color: #FFC603;

		.van-cell__right-icon {
			color: #FFC603;
		}
	}

	.van-collapse-item__wrapper {
		min-height: 40px;
		display: block !important;
	}

	.van-collapse-item__content {
		color: #333333;
		padding: 0;
	}

	.van-cell::after {
		border: none;
	}

	.van-hairline--top-bottom::after,
	.van-hairline-unset--top-bottom::after {
		border: none;
	}
}

.collapse {
	.van-collapse-item__title {
		display: none !important;
	}
}

.kong {
	img {
		display: block;
		width: 100px;
		height: 100px;
		margin: 0 auto;
		margin-top: 144px;
		margin-bottom: 50px;
	}

	span {
		display: inline-block;
		width: 100%;
		text-align: center;
		color: #666;
	}
}

.brand-box {
	.van-collapse-item__content {
		background: #fffaf0;
	}

	.van-cell {
		background: #fffaf0;
	}
}

.fl-left {
	.van-sidebar-item {
		font-size: 15px;
		color: #666;
	}

	.van-sidebar-item--select {
		color: #FFAA00;
	}

	.van-sidebar-item--select::before {
		width: 4px;
		height: 30px;
		background: #FFC603;
		border-radius: 2px 2px 2px 2px;
		left: 1px;
	}
}

.custom-image {
	position: fixed;
	top: 36vh;
	z-index: 100;
	width: 100vw;
	left: 50%;
	transform: translate(-50%, 0);

	.van-empty__image {
		width: 100px;
		height: 100px;
	}

	.van-empty__description {
		margin-top: 30px;
		font-size: 12px;
	}
}

.van-dialog__confirm,
.van-dialog__confirm:active {
	color: #000;
}

.van-nav-bar {
	.van-icon {
		color: #000 !important;
	}

	.van-nav-bar__text {
		color: #000 !important;
	}
}

.pinpai-list {
	cell {
		font-size: 14px;
		color: #666666;
		height: 45px;
		line-height: 25px;
		padding: 10px 0;
		display: block;
		border-top: 1px solid #ddd;
		box-sizing: border-box;
		padding-left: 15px;
		background: #fff;
	}
}

.brand-box {
	.van-index-anchor--sticky {
		color: #FFC603 !important;
		font-size: 16px;
	}

	.van-index-bar__index {
		font-size: 14px;
		background: #fff;
		line-height: 1.2;
	}

	.van-index-bar__index--active {
		color: #FFC603 !important;
	}
}

.sell-ershou {
	.one.van-cell {
		display: block;

		.van-cell__title {
			display: block;
			width: 100%;
			font-size: 14px;
		}

		.van-cell__value {
			display: block;
			width: 92vw;
			background: #EEEEEE;
			border-radius: 6px;
			padding: 10px 0 10px 15px;
			position: relative;
			top: 10px;
		}
	}

	.two.van-cell {
		width: 92vw;
		margin: 15px auto;
		padding: 10px 0 10px 15px;
		background: #EEEEEE;
		border-radius: 6px;

		.van-field__control {
			text-align: right;
			padding-right: 15px;
		}
	}
}

.twoOver {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
}

// 隐藏 IndexBar 点击/滑动时的 toast 大字（可能渲染到 body 层级）
.van-index-bar__toast {
	display: none !important;
}

// 取消右侧索引栏选中高亮色
.van-index-bar__index--active {
	color: inherit !important;
}

// 取消 sticky 锚点的特殊颜色
.van-index-anchor--sticky {
	color: inherit !important;
}

.main {
	// background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue